export {default as NoOrder} from './NoOrder.connect';
